// Remove the preloader after the page has loaded
! ((doc, win) => {
    let preloader = doc.querySelector('#preloader')
    if (preloader) {
        win.addEventListener('load', () => {
            preloader.classList.add('fade-out');
            setTimeout(() => {
                preloader.remove();
            }, 300);
        })
    }
})(document, window)